import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=4d1805f0&"
import script from "./Macro.vue?vue&type=script&lang=js&"
export * from "./Macro.vue?vue&type=script&lang=js&"
import style0 from "./Macro.vue?vue&type=style&index=0&id=4d1805f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports